export default "__VITE_ASSET__ClVwDGoS__"